// Refer to the AnalyticsOverrideProps and AnalyticsParentDataProps types

export const analyticsOverrideAttrs = ['analytics', 'analytics-label-override'];
export const analyticsParentDataAttrs = ['analytics-parent-heading', 'analytics-parent-type'];